module.exports = __webpack_public_path__ + "img/logo-zakony.3b4f299b.svg";